module.exports = __webpack_public_path__ + "static/img/icon-arrow-down-light.1bfa83b1.svg";